import React from 'react'

import { primitivePropsAreEqual } from 'helpers/react'

import { Typo } from 'components/_old/Typo'

import { Typography } from 'components/atoms/Typography'

import { getColor, formatValue, sortYearly } from '../model'

import './PastPerformanceTable.css'

type PastPerformanceTableCellProps = {
  children: React.ReactNode
  size?: number
  color?: string
  align?: 'right' | 'left'
}

const PastPerformanceTableCell = ({
  children,
  size = 16,
  color = 'additional',
  align,
}: PastPerformanceTableCellProps): JSX.Element => (
  <Typography size={size} lineHeight="small" color={color} align={align} numeric="tabular">
    <Typo>{children}</Typo>
  </Typography>
)

type PastPerformanceTableProps = {
  yearly: Record<string, string> | undefined
}

const PastPerformanceTable = React.memo<PastPerformanceTableProps>(({ yearly }) => {
  if (!yearly) {
    return null
  }

  const yearlySorted = sortYearly(yearly)

  return (
    <table className="PastPerformanceTable" width="100%">
      <thead>
        <tr>
          <th scope="col">
            <PastPerformanceTableCell size={14} color="minor">
              Year
            </PastPerformanceTableCell>
          </th>
          <th scope="col">
            <PastPerformanceTableCell size={14} color="minor" align="right">
              Annual returns
            </PastPerformanceTableCell>
          </th>
        </tr>
      </thead>
      <tbody>
        {yearlySorted.map(([year, value]) => (
          <tr key={year}>
            <th scope="row">
              <PastPerformanceTableCell>{year}</PastPerformanceTableCell>
            </th>
            <td>
              <PastPerformanceTableCell color={getColor(value)} align="right">
                {formatValue(value)}
              </PastPerformanceTableCell>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}, primitivePropsAreEqual)
PastPerformanceTable.displayName = 'PastPerformanceTable'

export { type PastPerformanceTableProps, PastPerformanceTable }
